import React from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { AES, enc } from "crypto-js";
import ClientProfile from "../../../components/Clients/ClientProfile/ClientProfile";
import { isMvpEnv } from "../../../utils/brandLogo";
import { useClientView } from "../../../components/TimeTracker/TimeTrackerClient/useClientDetails";
import MvpClientChrome from "../mvpDetails/MvpClientChrome";
import MvpClientProfileView from "../mvpDetails/MvpClientProfile";

function MvpClientProfile() {
    const { encryptedId } = useParams();
    const token = useSelector((state) => state.auth.token);
    const decodedId = decodeURIComponent(String(encryptedId || "").replace(/%2F/g, "/"));
    const id = AES.decrypt(decodedId, "encryptionKey").toString(enc.Utf8);
    const { data: client } = useClientView(id, token);

    return (
        <MvpClientChrome client={client} encryptedId={encryptedId}>
            <MvpClientProfileView client={client} />
        </MvpClientChrome>
    );
}

function ClientProfileSection()  {
    if (isMvpEnv()) return <MvpClientProfile />;
    return(
        <div className="profile-section-outer">
            <ClientProfile />
        </div>
    )
}

export default ClientProfileSection;